import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosCotizacionGenerar', {
    template: template,
    controller: NominasNominaDocumentosCotizacionGenerarComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      onClose: '&',
      onChange: '&',
    },
  })

function NominasNominaDocumentosCotizacionGenerarComponent(NominasNominaDocumentosCotizacion, NominasNominaDocumentosCotizacionConfiguracion) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges
  $ctrl.cerrar = cerrar
  $ctrl.generar = generar

  function $onInit() {
    $ctrl.promise = NominasNominaDocumentosCotizacionConfiguracion.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.data = response.data
      })
  }

  function $onChanges(changes) {
    if (changes.data)
      $ctrl.data = angular.copy(changes.data.currentValue)
  }

  function generar() {
    $ctrl.link = NominasNominaDocumentosCotizacion.get($ctrl.data)

    delete $ctrl.data.guardar_configuracion

    if ($ctrl.data.guardar_configuracion) {
      $ctrl.onChange({$event: {data: $ctrl.data}})
    }

    cerrar()
  }

  function cerrar() {
    $ctrl.onClose()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/cotizacion/generar/componet.js